import React, { PureComponent } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import InfoSvg from '../UI/infoSvg';
import CloseRoundSvg from '../UI/closeRoundSvg';
import { ToggleLockInModal, ToggleProgressModal } from '../../../actions/utils';
import { bindActionCreators } from 'redux';
import { store } from '../../../index';
import { SET_BOOKING_DETAILS } from '../../../actions/types';
import { UpdateBookingStatus } from '../../../actions/booking';
import { withApollo } from 'react-apollo';
import cookie from "js-cookie";
import { isLocalHost } from '../../../helpers/utils';
ReactModal.setAppElement('#root');

class LockInModal extends PureComponent{

    constructor(props){
        super(props);
        this.state = {
            showModel:false
        }
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }



    openModal(){ this.setState({showModel:true}); }
    closeModal(){ 
        this.setState({showModel:false}); 
        this.props.ToggleLockInModal(false);
    }

    componentDidUpdate(prevProps, prevState){
      
        const { lockinModalIsOpen } = this.props;

        if(lockinModalIsOpen !== prevProps.lockinModalIsOpen){
            lockinModalIsOpen ? this.openModal() :  this.closeModal();
        }
    }

    onConfirm(){

        const { currentBooking:{uuid}, client, ToggleProgressModal } = this.props;
        const token = cookie.get("ap.token");

        this.closeModal();

        //Show progress modal 
        ToggleProgressModal(true);
   
        //Update booking status
        UpdateBookingStatus(client, uuid, 'checkout').then(()=>{

            ToggleProgressModal(false);
            
            if(isLocalHost()){
                window.location.href = `${process.env.REACT_APP_BOOKING_URL}${process.env.REACT_APP_PAYMENT_PAGE}?id=${uuid}&t=${token}`
            }else{
                window.location.href = `https://www.busabout.com${process.env.REACT_APP_PAYMENT_PAGE}?id=${uuid}&t=${token}`;
            }

            //Clear current booking 
            store.dispatch({type:SET_BOOKING_DETAILS, payload:{}});
        });

    }

    render(){

        const { showModel } = this.state;

        return (
            showModel && (
                <ReactModal
                    className="include-modal basket"
                    overlayClassName="modal-overlay white"
                    isOpen={showModel}
                    onRequestClose={this.closeModal}
                    contentLabel="Include modal">
                
                    <div className="max-width-5 mx-auto clearfix">
                        <div className="col col-12 center">

                            <InfoSvg />

                            <h4 className="mb1 mt2 black-text">Ready to lock-in this itinerary?</h4>
                            <p className="medium margin-b-30 black-text">To continue to payment we need to confirm this itinerary to hold availability. You will not be able to edit your trip from this point forward.</p>
                            <button type="button" className="busabout--cta orange rounded-corner inline" onClick={this.onConfirm}>
                                Continue and lock-in
                            </button>
                        </div>

                        <div className="col col-12 px2">
                            <button className="modal-close" onClick={this.closeModal}><CloseRoundSvg /></button>
                        </div>
                    </div>
                </ReactModal>                      
            )
        )
    }
}


const mapStateToProps = state => {
    return{
        currentBooking:state.currentBooking,
        lockinModalIsOpen:state.toggleModal.lockinModalIsOpen,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        ToggleLockInModal,
        ToggleProgressModal
    }, dispatch);
}

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(LockInModal));